<template>
  <span class="layout-miniature" :class="{ active }">
    <span
      v-for="(segment, index) in previewSegments"
      :key="`${layout.name}-${segment}-${index}`"
      class="layout-miniature-segment"
      :class="segmentClassName(segment)"
    />
  </span>
</template>

<script>
export default {
  name: "LayoutMiniature",
  props: {
    layout: { type: Object, required: true },
    active: { type: Boolean, default: false },
  },
  computed: {
    previewSegments() {
      if (!this.layout || !this.layout.positions) {
        return ["none"];
      }
      const values = Object.values(this.layout.positions);
      return values.length ? values : ["none"];
    },
  },
  methods: {
    segmentClassName(segment) {
      if (!segment) return "none";
      return segment
        .replace(/([a-z0-9])([A-Z])/g, "$1-$2")
        .replace(/_/g, "-")
        .toLowerCase();
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-miniature {
  position: relative;
  flex-shrink: 0;
  width: 58px;
  height: 38px;
  border: 1px solid rgba(255, 255, 255, 0.25);
  border-radius: 3px;
  background: rgba(255, 255, 255, 0.08);
  overflow: hidden;
  display: inline-block;

  &.active {
    border-color: rgba(90, 140, 255, 0.9);
  }
}

.layout-miniature-segment {
  position: absolute;
  background: rgba(124, 174, 255, 0.85);

  &.none {
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    border-radius: 2px;
  }
  &.sidebar-left   { left: 0;   top: 20%;    width: 20%; height: 60%; }
  &.sidebar-right  { right: 0;  top: 20%;    width: 20%; height: 60%; }
  &.top-bar        { top: 0;    left: 0;     width: 100%; height: 18%; border-radius: 0;     padding: 0 !important;}
  &.bottom-bar     { bottom: 0; left: 0;     width: 100%; height: 18%; }
  &.top-bar-left   { top: 0;    left: 0;     width: 20%; height: 18%; }
  &.top-bar-right  { top: 0;    right: 0;    width: 20%; height: 18%; }
  &.bottom-bar-left  { bottom: 0; left: 0;   width: 20%; height: 18%; }
  &.bottom-bar-right { bottom: 0; right: 0;  width: 20%; height: 18%; }
}
</style>

